// Numeric codes arrive as numbers.
export const toSearchText = (searchValue: unknown) =>
	typeof searchValue === "string" || typeof searchValue === "number"
		? String(searchValue)
		: undefined;
